import {
    ContactFormEvents,
    IGenericConfig,
    IContactFormEvent,
    IContactFormPaymentTokenEventData
} from '../types/client-exprience.types';
import type { CXRootStore } from '../../stores/cx-root.store';
import { Routes } from '../stores/instant-pay.store';
import { CXEnvironments } from '~/types/cx-types/cx-environment.types';

export class GiftCardCXController {
    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    async loadCompanyBranding() {
        const { companyService, giftCardCXStore } = this.rootStore;

        giftCardCXStore.setCompanyBrandingData(
            await companyService.fetchCompanyBrandingData(
                giftCardCXStore.placementId
            )
        );
    }

    async loadUserConfig() {
        const { userService, giftCardCXStore } = this.rootStore;

        giftCardCXStore.setUserConfig(
            await userService.fetchUserConfig(giftCardCXStore.placementId)
        );
    }

    async loadGenericConfig() {
        const {
            configService,
            giftCardCXApiService,
            clientPortalConfigStore: { env },
            giftCardCXStore
        } = this.rootStore;
        let configJsonP: IGenericConfig = null;

        if (env.environment === CXEnvironments.Development) {
            configJsonP =
                await giftCardCXApiService.fetchPlacementGenericConfigNonProd();
        } else {
            configJsonP = await configService.fetchPlacementGenericConfig();
        }

        giftCardCXStore.setGenericConfig(configJsonP);
    }

    getContactFormPostMessageLoadJson() {
        const { giftCardCXStore, clientPortalConfigStore } = this.rootStore;
        const contactForm = giftCardCXStore.userConfig.contact_forms.find(
            currContactForm => {
                return currContactForm._id === giftCardCXStore.cfId;
            }
        );
        const { placement_id, data_version, schema_version, company } =
            giftCardCXStore.userConfig;
        const { isPreview } = clientPortalConfigStore;
        const { companyBrandingData } = giftCardCXStore;

        return JSON.parse(
            JSON.stringify({
                hbEvent: {
                    type: 'hb_contact_form_json',
                    contact_form: contactForm,
                    placement_id,
                    placement_data_version: data_version,
                    placement_schema_version: schema_version,
                    runtimeConfig: {
                        is_direct_link: true,
                        is_preview: isPreview,
                        contact_form_selector: ''
                    },
                    runtimeConfigOverwrite: {},
                    company: { ...company, ...companyBrandingData },
                    genericConfig: giftCardCXStore.genericConfig,
                    collector_data: {
                        referrer: document.referrer,
                        location: document.location.href
                    }
                }
            })
        );
    }

    contactFormEventsHandler(e: IContactFormEvent) {
        const { giftCardCXStore } = this.rootStore;

        if (!e.data.hbEvent || !e.data.hbEvent.type) {
            return;
        }

        switch (e.data.hbEvent.type) {
            case ContactFormEvents.ContactFormMounted:
                giftCardCXStore.setHbContactFormState('mounted');
                break;
            case ContactFormEvents.PaymentTokenReceived:
                giftCardCXStore.setHbToken(
                    (e.data.hbEvent as IContactFormPaymentTokenEventData)
                        .hb_token
                );
                break;
            case ContactFormEvents.StickyHeaderStateReceived:
                giftCardCXStore.setStickyHeaderState({
                    ...e.data.hbEvent.data
                });
                giftCardCXStore.setHbContactFormState('loaded');
                break;
            case ContactFormEvents.ContactFormScrolled:
                giftCardCXStore.setStickyHeaderState({
                    ...giftCardCXStore.stickyHeaderState,
                    isSticky: e.data.hbEvent.pageYOffset > 0
                });
                break;
            case ContactFormEvents.ContactFormStaleError:
                giftCardCXStore.setHbContactFormState('stale');
                break;
            default:
            // not handling other events
        }
    }

    checkoutFormPreviewEventHandler(e: IContactFormEvent) {
        const { configStore, clientPortalConfigStore, instantPayStore } =
            this.rootStore;

        if (
            !e.data.hbEvent ||
            !e.data.hbEvent.type ||
            e.data.hbEvent.type !==
                ContactFormEvents.CheckoutPreviewDataReceived
        ) {
            return;
        }

        const { gon, paymentData, clientPortalConfig } = e.data.hbEvent.data;

        clientPortalConfigStore.setClientPortalConfiguration(
            clientPortalConfig
        );
        configStore.setConfig(gon);
        instantPayStore.updatePaymentData(paymentData);
        instantPayStore.setActiveRoute(Routes.CheckoutForm);
    }
}
